import { render, staticRenderFns } from "./calyrafit-best-saller.vue?vue&type=template&id=47f168a6&scoped=true&"
import script from "./calyrafit-best-saller.vue?vue&type=script&lang=js&"
export * from "./calyrafit-best-saller.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-best-saller.vue?vue&type=style&index=0&id=47f168a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f168a6",
  null
  
)

export default component.exports